var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contract-invoice" },
    [
      _c(
        "div",
        { staticClass: "contract-invoice__header" },
        [
          _c("h2", { staticClass: "contract-invoice__header-title" }, [
            _vm._v(_vm._s(_vm.i18n.cont_invoices()))
          ]),
          _vm._v(" "),
          _vm.isRequestor
            ? _c(
                "md-button",
                {
                  staticClass: "md-primary",
                  attrs: { disabled: _vm.contractCompleted },
                  on: {
                    click: function($event) {
                      _vm.isCreatingInvoice = true
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.i18n.cont_create_invoice()))]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "contract-invoice__wrapper" },
        [
          _vm.list.length
            ? [
                _c("div", { staticClass: "contract-invoice__row-header" }, [
                  _c(
                    "div",
                    { staticClass: "contract-invoice__number-column" },
                    [_vm._v(_vm._s(_vm.i18n.cont_invoice_number()))]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "contract-invoice__state-column" }, [
                    _vm._v(_vm._s(_vm.i18n.lbl_state()))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "contract-invoice__type-column" }, [
                    _vm._v(_vm._s(_vm.i18n.lbl_request_type()))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "contract-invoice__date-column" }, [
                    _vm._v(_vm._s(_vm.i18n.lbl_date()))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "contract-invoice__funds-column" }, [
                    _vm._v(_vm._s(_vm.i18n.lbl_funds()))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "contract-invoice__button-column" })
                ]),
                _vm._v(" "),
                _vm._l(_vm.list, function(item, i) {
                  return [
                    _c(
                      "div",
                      {
                        key: i,
                        staticClass: "contract-invoice__row",
                        class: {
                          "contract-invoice__row--active": _vm.isSelected(i)
                        }
                      },
                      [
                        _c("div", { staticClass: "contract-invoice__item" }, [
                          _c(
                            "div",
                            { staticClass: "contract-invoice__number-column" },
                            [_vm._v(_vm._s(item.invoiceNumber))]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "contract-invoice__state-column" },
                            [
                              _vm._v(
                                _vm._s(
                                  item.state ===
                                    _vm.REQUEST_STATES_STR.permanentlyRejected
                                    ? _vm.REQUEST_STATES_STR.rejected
                                    : item.state.split("_").join(" ")
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "contract-invoice__type-column" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.isRequestor
                                    ? _vm.i18n.cont_type_outgoing()
                                    : _vm.i18n.cont_type_incoming()
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "contract-invoice__date-column" },
                            [_vm._v(_vm._s(_vm.i18n.d(item.createdAt)))]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "contract-invoice__funds-column" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.roundCurrency(item.amount, item.asset)
                                ) +
                                  " " +
                                  _vm._s(item.asset) +
                                  " "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "contract-invoice__button-column" },
                            [
                              _c(
                                "md-button",
                                {
                                  staticClass:
                                    "contract-invoice__open-details-btn md-icon-button",
                                  on: {
                                    click: function($event) {
                                      return _vm.toggleDetails(i)
                                    }
                                  }
                                },
                                [
                                  _vm.isSelected(i)
                                    ? _c("md-icon", [
                                        _vm._v("keyboard_arrow_up")
                                      ])
                                    : _c("md-icon", [
                                        _vm._v("keyboard_arrow_down")
                                      ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _vm.isSelected(i)
                          ? _c(
                              "div",
                              {
                                key: "selected-" + i,
                                staticClass: "contract-invoice__item-details"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "md-title contract-invoice__title"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.i18n.cont_invoice_information()
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "contract-invoice__document-details-row"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "contract-invoice__document-name"
                                      },
                                      [
                                        _c("h3", [
                                          _vm._v(
                                            _vm._s(_vm.i18n.lbl_documents())
                                          )
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "contract-invoice__document-submitter"
                                      },
                                      [
                                        _c("h3", [
                                          _vm._v(
                                            _vm._s(_vm.i18n.lbl_submitted_by())
                                          )
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "contract-invoice__document-type"
                                      },
                                      [
                                        _c("h3", [
                                          _vm._v(_vm._s(_vm.i18n.lbl_type()))
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass:
                                        "contract-invoice__documents-view-btn"
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "contract-invoice__document-details-row"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "contract-invoice__document-name"
                                      },
                                      [
                                        _c(
                                          "i",
                                          {
                                            staticClass:
                                              "document-icon material-icons"
                                          },
                                          [_vm._v("note")]
                                        ),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(_vm._s(item.invoiceFileName))
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "contract-invoice__document-submitter"
                                      },
                                      [
                                        _c("company-name-getter", {
                                          attrs: { id: item.requestor }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "contract-invoice__document-type"
                                      },
                                      [
                                        _c("p", [
                                          _vm._v(_vm._s(item.invoiceFileType))
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "contract-invoice__documents-view-btn"
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: item.invoiceFileUrl,
                                              target: "_blank"
                                            }
                                          },
                                          [_vm._v(_vm._s(_vm.i18n.lbl_open()))]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("detail-row", {
                                  attrs: {
                                    prop: _vm.i18n.lbl_note(),
                                    value: item.note,
                                    alignLeft: true,
                                    colWidth: [15, 85]
                                  }
                                }),
                                _vm._v(" "),
                                item.state ===
                                _vm.REQUEST_STATES_STR.permanentlyRejected
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "contract-invoice__reject-details"
                                      },
                                      [
                                        _c(
                                          "h3",
                                          {
                                            staticClass:
                                              "contract-invoice__reject-details-title"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.i18n.lbl_reject_reason()
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(item.rejectReason) +
                                            "\n          "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "md-card-actions",
                                  { staticClass: "dispute-btn-wrapper" },
                                  [
                                    !_vm.isRequestor &&
                                    item.state ===
                                      _vm.REQUEST_STATES_STR.pending
                                      ? _c(
                                          "md-button",
                                          {
                                            staticClass: "md-primary",
                                            attrs: { disabled: _vm.isPending },
                                            on: {
                                              click: function($event) {
                                                return _vm.rejectSelectedRequest(
                                                  item
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.i18n.lbl_reject())
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.isRequestor &&
                                    item.state ===
                                      _vm.REQUEST_STATES_STR.pending
                                      ? _c(
                                          "md-button",
                                          {
                                            staticClass: "md-primary",
                                            attrs: { disabled: _vm.isPending },
                                            on: {
                                              click: function($event) {
                                                return _vm.confirmInvoiceRequest(
                                                  item
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.i18n.lbl_confirm())
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    )
                  ]
                }),
                _vm._v(" "),
                !_vm.isLoaded
                  ? [
                      _c(
                        "div",
                        { staticClass: "contract-invoice__btn-outer" },
                        [
                          _c(
                            "md-button",
                            {
                              attrs: { disabled: _vm.isLoading },
                              on: { click: _vm.more }
                            },
                            [_vm._v(_vm._s(_vm.i18n.lbl_view_more()))]
                          )
                        ],
                        1
                      )
                    ]
                  : _vm._e()
              ]
            : [
                _c(
                  "div",
                  { staticClass: "contract-invoice__no-invoices" },
                  [
                    _c("md-icon", { staticClass: "md-size-4x" }, [
                      _vm._v("trending_up")
                    ]),
                    _vm._v(" "),
                    _c("h2", [
                      _vm._v(_vm._s(_vm.i18n.cont_no_invoice_requests()))
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(_vm._s(_vm.i18n.cont_no_invoice_requests_desc()))
                    ])
                  ],
                  1
                )
              ]
        ],
        2
      ),
      _vm._v(" "),
      _vm.isCreatingInvoice
        ? _c(
            "modal",
            {
              attrs: { maxWidth: "1200px" },
              on: {
                "close-request": function($event) {
                  _vm.isCreatingInvoice = false
                }
              }
            },
            [
              _c("create-invoice", {
                attrs: {
                  contractId: _vm.contractId,
                  customerId: _vm.customerId,
                  invoiceAsset: _vm.currentAsset
                },
                on: {
                  "asset-change": _vm.setCurrentAsset,
                  "close-request": function($event) {
                    _vm.isCreatingInvoice = false
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isRejectingRequest
        ? _c(
            "modal",
            {
              attrs: { maxWidth: "800px" },
              on: {
                "close-request": function($event) {
                  _vm.isRejectingRequest = false
                }
              }
            },
            [
              _c("reject-form", {
                on: {
                  "submit-reject-message": _vm.rejectInvoiceRequest,
                  "close-request": function($event) {
                    _vm.isRejectingRequest = false
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-04b7d716", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04b7d716","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/contracts/index/Contracts.Invoice.vue
// module id = +EvP
// module chunks = 1